<template>
  <div class="resources">
    <div class="banner ">
      <div class="text">
        <h2>{{ $t('resources.title') }}</h2>
        <p>{{ $t('resources.subTitle') }}</p>
      </div>
      <div class="pic">
        <div class="shape" />
      </div>
    </div>
    <CommonChannelFilter v-show="showFilter" :show-title="false" :location="location" :default-selected-channel-id="`${defaultChannelId}`" @channel-change="handleChannelChange" />

    <div class="content-wrap">
      <MessageForm />
      <div class="resources-data">
        <template v-if="initLoading">
          <Loading :show="initLoading" />
        </template>
        <ResourceContent v-else :data.sync="list" />
      </div>
    </div>
  </div>
</template>

<script>

import MessageForm from 'components/common/MessageForm'
import { resetUrlParams } from 'common/utils';
import Loading from 'components/common/Loading/index.vue';
import ResourceContent from 'components/resources/ResourceContent'

import CommonChannelFilter from 'components/courses/CommonChannelFilter';
import { oneApi } from 'config/api'

export default {
  components: {
    ResourceContent, MessageForm, CommonChannelFilter, Loading,
  },
  async fetch({
    store, $axios, redirect, error, res,
  }) {
    const { locale, localeConfig } = store.state;
    if (locale === 'us') {
      // redirect('/resource')
      if (process.server) {
        res.writeHead(301, { Location: '/resource' });
        res.end();
      } else {
        redirect(301, '/resource');
      }
      return
    }
    if (!localeConfig.enableResourcesPage) {
      const params = {
        statusCode: 404,
      };
      error(params);
    }
    await store.dispatch('courses/queryFilter', { $axios, mallGroup: 5 })
  },

  data() {
    const channelIdInUrl = this.$route.query.channel || ''
    const channelIdInStore = this.$store.state.channel.selectedResourcesChannelId || ''
    const defaultChannelId = channelIdInUrl || channelIdInStore || ''
    return {
      initLoading: true,
      defaultChannelId,
      location: 'resources',
      list: {},
    }
  },
  computed: {
    showFilter() {
      if (this.$store.state.courses.queryFilter.channels && this.$store.state.courses.queryFilter.channels.length > 1) {
        return true
      }
      if (this.$store.state.courses.queryFilter.channelGroups) {
        let channel = 0
        this.$store.state.courses.queryFilter.channelGroups.forEach((item) => {
          channel += item.channels.length
        })
        if (channel > 1) {
          return true
        }
      }
      return false
    },
  },
  mounted() {
    if (!this.$store.state.channel.selectedResourcesChannelId) {
      this.getData()
    }
  },

  methods: {
    handleChannelChange(selectedChannelId) {
      this.$store.commit('channel/SET_SELECTED_RESOURCES_CHANNEL_ID', selectedChannelId)

      resetUrlParams({
        channel: this.$store.state.channel.selectedResourcesChannelId,
      }, false)
      this.getData()
    },
    async getData() {
      this.initLoading = true
      const data = {
        specValues: [{
        // 频道
          specId: 25,
          specValue: this.$store.state.channel.selectedResourcesChannelId || '',
        }, {
        // position参数
          specId: 24,
          specValue: 5,
        }],
      }
      const res = await this.$axios.post(oneApi.queryMallPage, data, { rewritePostBody: true });
      if (Number(res.code) !== 0) {
        return
      }
      const resData = res.data || {}
      this.list = resData.moduleContents
      this.initLoading = false
    },
  },
  head() {
    return {
      script: [
        { src: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/libs/aws-sdk/2.317.0/aws-sdk.min.js', defer: true },
      ],
    };
  },
}
</script>
<style lang="scss" scoped>
.resources {
  width: 1160px;
  margin: 0 auto;
  min-height: calc(100vh - 80px);

  .banner {
    display: flex;
    padding: 24px 0;
    justify-content: space-between;

    .text {
      display: flex;
      flex-direction: column;
      justify-content: center;

      h2 {
        width: 564px;
        font-size: 54px;
        font-weight: bold;
        color: var(--txt-color-lv1);
        line-height: 56px;
      }

      p {
        margin-top: 20px;
        width: 534px;
        font-size: 16px;
        font-weight: 500;
        color: var(--txt-color-lv1);
        line-height: 20px;
      }
    }

    .pic {
      border-radius: 10px;
      overflow: hidden;
      width: 610px;
      height: 311px;
      transform: skewX(-12deg);
      margin-right: -38px;

      .shape {
        margin-left: -10px;
        width: 610px;
        height: 311px;
        background: url('~assets/images/resources/banner.png') no-repeat;
        background-size: 100%;
        border-radius: 10px;
        font-size: 20px;
        font-weight: 600;
        color: #fff;
        line-height: 24px;
        transform: skewX(12deg);
        transform-origin: bottom right;
        overflow: visible;
        padding-left: 10px;
      }
    }
  }

  .content-wrap {
    height: auto;
    min-height: 700px;
    margin-bottom: 80px;
  }

  .resources-data {
    margin-top: 40px;
  }
}
</style>
